import { takeLatest, put, delay } from 'redux-saga/effects';


import * as TYPES from '../actions/types';
import { loaderAction, loaderActionMainApp, saveDocumentUrl, savePendingDoc, saveSignedDoc, saveDocIsLocked,saveIsClientFillable } from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { doc } from '../../services/docuemnt';



export function* getSignedDocSaga() {
  try {
    yield takeLatest(TYPES.GET_SIGNED_DOC, getSignedDocWorker);
  } catch (err) {
  }
}

function* getSignedDocWorker(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield doc.getSignedDoc(param['payload']);
    yield put(saveSignedDoc(response));
    yield put(loaderAction(false));
  } catch (e) {
  }
}


export function* getPendingDocSaga() {
  try {
    yield takeLatest(TYPES.GET_PENDING_DOC, getPendingDocWorker);
  } catch (err) {
  }
}

function* getPendingDocWorker(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield doc.getPendingDoc(param['payload']);
    yield put(savePendingDoc(response));
    yield put(loaderAction(false));
  } catch (e) {
  }
}


export function* getDocumentUrlSaga() {
  try {
    yield takeLatest(TYPES.GET_DOCUMENT_URL, getDocumentUrlWorker);
  } catch (err) {
  }
}
function* getDocumentUrlWorker(param: any) {
  try {
    yield put(loaderActionMainApp(true));
    const response: GenericResponseModel = yield doc.getDocViewUrl();
    yield put(saveDocIsLocked(param['payload'].isLocked));
    yield put(saveIsClientFillable(param['payload'].isClientFillable));
    if (response && response.resultData) {
      yield put(
        saveDocumentUrl(
          `${response.resultData.redirectUrl}&docId=${param['payload'].docId}&editable=${param['payload'].tabId}&isUpdate=${param['payload'].isUpdate}&queId=${param['payload'].queId}&tabIdQue=${param['payload'].tabIdQue}&isUpdateQue=${param['payload'].isUpdateQue}&field=${param['payload'].field}&id=${param['payload'].id}&enumId=${param['payload'].enumId}&questionnaire=${param['payload'].questionnaire}&questionnaireId=${param['payload'].questionnaireId}`
        )
      );

    }

    yield put(loaderActionMainApp(false));
  } catch (e) {
  }
}


